import { IconProps } from './IconProps';
export function MegaphoneIcon(props: IconProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.5 6.90039V15.5554C7.49997 16.8957 7.87447 18.2093 8.58124 19.3481C9.28802 20.4869 10.2989 21.4055 11.5 22.0004"
                stroke="#66182A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.5 4.48431C21.5 4.31633 21.4577 4.15105 21.3769 4.00374C21.2962 3.85643 21.1796 3.73183 21.038 3.64145C20.8964 3.55107 20.7343 3.49781 20.5667 3.4866C20.3991 3.4754 20.2314 3.50659 20.079 3.57731C16.244 5.35631 12.456 6.96431 4.5 7.00031H3.5C2.70435 7.00031 1.94129 7.31639 1.37868 7.87899C0.81607 8.4416 0.5 9.20467 0.5 10.0003V12.0003C0.5 12.796 0.81607 13.559 1.37868 14.1216C1.94129 14.6842 2.70435 15.0003 3.5 15.0003H4.5C12.456 15.0363 16.244 16.6443 20.079 18.4233C20.2314 18.494 20.3991 18.5252 20.5667 18.514C20.7343 18.5028 20.8964 18.4496 21.038 18.3592C21.1796 18.2688 21.2962 18.1442 21.3769 17.9969C21.4577 17.8496 21.5 17.6843 21.5 17.5163V4.48431Z"
                stroke="#66182A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.5 9H22C22.3978 9 22.7794 9.15804 23.0607 9.43934C23.342 9.72064 23.5 10.1022 23.5 10.5V11.5C23.5 11.8978 23.342 12.2794 23.0607 12.5607C22.7794 12.842 22.3978 13 22 13H21.5"
                stroke="#66182A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
